import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LineChart,
  Line,
  Legend
} from "recharts";
import { GetAllData } from "../hooks/middleware.js";
import { CountItems, SortItems, GetTopItems, CountTotal } from "../hooks/chartMethods.js";

export default function TileSavings({ id, lightpointsPerYear }) {
  const { lightpointData, formData, error } = GetAllData(id);

  if (error) return <p>Error loading data.</p>;
  if (!lightpointData) return <p>Loading data...</p>;
  if (lightpointData.length === 0) return <p>No data found</p>;

 const { totalCurrentWattage, totalReplacementWattage } = lightpointData.reduce(
    (totals, lp) => {
      totals.totalCurrentWattage += lp.properties.lampcurwattage || 0;
      totals.totalReplacementWattage += lp.properties.lamprepwattage || 0;
      return totals;
    },
    { totalCurrentWattage: 0, totalReplacementWattage: 0 }
  );

  const totalLightpoints = lightpointData.length;
  const duration = Math.ceil(totalLightpoints / lightpointsPerYear);

  const deltaWattage = totalCurrentWattage - totalReplacementWattage;
  const deltaPerYear = deltaWattage / duration

 const yearlyWattage = [];
 let totalSavingKWh = 0;
 const NIGHT_HOURS = 4383; //4383 = night hours per year
  for (let year = 1; year <= 7; year++) {
    let value;
    if (year <= duration) {
      value = (totalCurrentWattage - deltaPerYear * (year - 1)) * NIGHT_HOURS / 1000; 
    } else {
      value = totalReplacementWattage * NIGHT_HOURS / 1000;
    }
    yearlyWattage.push({
      year,
      wattage: parseFloat(value.toFixed(0)),
    });
    totalSavingKWh += parseFloat(value.toFixed(0))
  }

  //const totalSavingKWh = (deltaWattage * NIGHT_HOURS / 1000).toFixed(0);
  totalSavingKWh -= totalCurrentWattage * 7;
  const CO2_FACTOR = 0.4;
  const totalCO2Saving = (totalSavingKWh * CO2_FACTOR).toFixed(0);

 return (
<div style={{ display: "flex", gap: "1rem", alignItems: "flex-start" }}>

  <div style={{ minWidth: "200px" }}>
    <div className="table-row" style={{ marginBottom: "4px" }}>
      <span style={{ minWidth: "150px" }}>Energieeinsparung</span>
      <span style={{ minWidth: "80px", textAlign: "right" }}>   
        {(Number(totalSavingKWh) || 0).toLocaleString("en-US")} kWh
      </span>
    </div>
    <div className="table-row">
      <span style={{ minWidth: "120px" }}>CO₂ Einsparung   </span>
      <span style={{ minWidth: "80px", textAlign: "right" }}>
        {(Number(totalCO2Saving) || 0).toLocaleString("en-US")} kg
      </span>
    </div>
  </div>

  <div style={{ flex: 1, height: 200 }}>
  <ResponsiveContainer width="100%" height="100%">
    <BarChart
      data={yearlyWattage}
      margin={{ top: 20, right: 20, left: 5, bottom: 0 }} // left margin small
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis
        dataKey="year"
        tickFormatter={(v) => `${v}`}
        tick={{ fontSize: 12 }}
      />
      <YAxis
        tickFormatter={(v) => `${v.toLocaleString("en-US")} kWh`}
        allowDecimals={false}
        width={50}
        tick={{ fontSize: 12 }}
        tickMargin={15}
      />
      <Tooltip
        formatter={(value) => [`${Number(value).toLocaleString("en-US")} kWh`]}
        labelFormatter={(label) => `Jahr ${label}`}
      />
      <Bar dataKey="wattage" fill="#f76e24" />
    </BarChart>
  </ResponsiveContainer>
</div>

</div>
  );
}